
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { User } from "@supabase/supabase-js";

interface UseLoginRedirectProps {
  user: User | null;
  authLoading: boolean;
  justLoggedIn: boolean;
  isAdmin: boolean;
  setJustLoggedIn: (value: boolean) => void;
}

export function useLoginRedirect({
  user,
  authLoading,
  justLoggedIn,
  isAdmin,
  setJustLoggedIn
}: UseLoginRedirectProps) {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const isAdminPanel = searchParams.get('admin') === 'true';

  useEffect(() => {
    // Só redireciona se o usuário acabou de fazer login (justLoggedIn = true)
    if (user && !authLoading && justLoggedIn) {
      if (isAdminPanel && isAdmin) {
        // User é admin e está acessando painel admin - permanece aqui
        setJustLoggedIn(false);
        return;
      } else if (isAdminPanel && !isAdmin) {
        // User não é admin mas está tentando acessar painel admin
        toast({
          title: "Acesso negado",
          description: "Você não tem permissão para acessar o painel administrativo.",
          variant: "destructive",
        });
        setJustLoggedIn(false);
        navigate("/meus-dados");
        return;
      } else if (!isAdminPanel) {
        // Login de usuário regular - redireciona para painel apropriado após delay
        setTimeout(() => {
          if (isAdmin) {
            navigate("/logins?admin=true");
          } else {
            navigate("/meus-dados");
          }
          setJustLoggedIn(false);
        }, 1000);
        return;
      }
    }
  }, [user, authLoading, justLoggedIn, isAdmin, isAdminPanel, navigate, toast, setJustLoggedIn]);

  return { isAdminPanel };
}
